var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticStyle: { flex: "0 0" }, attrs: { "pa-0": "" } },
    [
      _c(
        "div",
        { staticClass: "spaced-label-2 text-xs-center pt-2 pb-1 px-3" },
        [_vm._v("\n    Import summary\n  ")]
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "px-5" },
        [
          _c("ButtonLabel", {
            attrs: {
              count: _vm.errorCount,
              active: _vm.showError,
              label: "Error",
              color: "error",
            },
            on: {
              "update:active": function ($event) {
                _vm.showError = $event
              },
            },
          }),
          _vm._v(" "),
          _c("ButtonLabel", {
            attrs: {
              count: _vm.warningCount,
              active: _vm.showWarning,
              label: "Warning",
              color: "warning",
            },
            on: {
              "update:active": function ($event) {
                _vm.showWarning = $event
              },
            },
          }),
          _vm._v(" "),
          _c("ButtonLabel", {
            attrs: {
              count: _vm.infoCount,
              active: _vm.showInfo,
              label: "Info",
              color: "info",
            },
            on: {
              "update:active": function ($event) {
                _vm.showInfo = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }